import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "#environments/environment";
import { Injectable } from "@angular/core";
import { Site } from "#models/site.model";
import { Observable, of } from "rxjs";
import { tap, shareReplay } from "rxjs/operators";

@Injectable()
export class SiteService {
  private sitesCache$: Observable<Site[]> | null = null;
  private siteByIdCache = new Map<number, Observable<Site>>();

  constructor(private http: HttpClient) {}

  getList({ cache = true } = {}): Observable<Site[]> {
    
    if (!cache || !this.sitesCache$) {
      let url = `${environment.apiEndpoint}/sites`;
      let options = {};

      if (!cache) {
        options = {
          headers: new HttpHeaders({
            "Cache-control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
          }),
        };
        
        this.sitesCache$ = null;
        this.siteByIdCache.clear();
      }
      this.sitesCache$ = this.http.get<Site[]>(url, options).pipe(
        shareReplay(1) // Share and replay last value to all subscribers
      );
    }

    return this.sitesCache$;
  }

  getById(siteId: number): Observable<Site> {
    // Check if we have this site cached
    if (!this.siteByIdCache.has(siteId)) {
      // Cache individual site request
      const site$ = this.http.get<Site>(`${environment.apiEndpoint}/sites/${siteId}`).pipe(
        shareReplay(1)
      );
      this.siteByIdCache.set(siteId, site$);
    }

    return this.siteByIdCache.get(siteId)!;
  }

 
getPhase3ById(siteId: number): Observable<Site> {
  return this.http.put<Site>(
    `${environment.apiEndpoint}/sites/${siteId}/SitePhase3AllInRate`,
    {}
  );
}

validateSite(payload: Site): Observable<Site> {
  return this.http.put<Site>(
    `${environment.apiEndpoint}/sites/${payload.ID}/validate`,
    payload
  ).pipe(
    tap(() => {
      this.clearCache();
    })
  );
}



  post(payload: Site): Observable<Site> {
    return this.http.post<Site>(`${environment.apiEndpoint}/sites`, payload).pipe(
      tap(() => {
        // Clear cache when new site is created
        this.clearCache();
      })
    );
  }

  put(payload: Site): Observable<Site> {
    return this.http.put<Site>(
      `${environment.apiEndpoint}/sites/${payload.ID}`,
      payload
    ).pipe(
      tap(() => {
        
        this.clearCache();
      })
    );
  }

  clearCache(): void {
    this.sitesCache$ = null;
    this.siteByIdCache.clear();
  }
}
